import React from 'react';
import { Col, FlexRow, Pill, Body } from '@edreamsodigeo/prisma-design-system';
import { Animation } from '@/components/Animation';

export const FreePill = ({ children, icon, animated = true }) => {
  return (
    <>
      {animated ? (
        <Animation.BalanceSpring>
          <PillComponent animated={animated} icon={icon}>
            <Animation.BlurText>
              <PillContent>{children}</PillContent>
            </Animation.BlurText>
          </PillComponent>
        </Animation.BalanceSpring>
      ) : (
        <PillComponent icon={icon}>
          <PillContent>{children}</PillContent>
        </PillComponent>
      )}
    </>
  );
};

const PillComponent = ({ children, icon }) => (
  <Pill
    type={'deals'}
    theme={'default'}
    rounded
    sx={{ maxWidth: '175px', paddingTop: '1px', paddingBottom: '0' }}
  >
    <FlexRow gap={1} flexDirection="row" alignItems="center">
      {icon && <Col>{icon}</Col>}
      <Col>{children}</Col>
    </FlexRow>
  </Pill>
);

const PillContent = ({ children }) => (
  <Body type="small" weight="medium" px="x_small" textAlign="center">
    {children}
  </Body>
);
